<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" v-bind="attrs" v-on="on">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </template>
    <v-card>
      <div class="padding-card">
         <p class="title-modal">Cambiar estado a pago Pendiente</p>
         <v-form>
          <v-col cols="12">  
            <v-autocomplete
            dense                      
            return-object
            v-model="status"
            :items="[ {key:'pending', value:'Pendiente'}]"
            item-value="key"
            item-text="value"
            label="Estatus de Pago"  
          >
        </v-autocomplete>       
          </v-col>
         </v-form>
      </div>
      <v-card-actions>
        <v-btn color="primary" @click="updateStatus"> Aceptar </v-btn>       
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    payment: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true      
    }
  },
  components: {
   
  },
  data: () => ({
    dialog: false,
    status: {key:'pending', value:'Pendiente'},
  }),
 
  methods:{
    updateStatus() {
      this.$emit('updateStatus', this.payment.id);
      this.dialog = false;
    },
    
  }
};
</script>

<style lang="scss" scoped>
@import './src/assets/style.scss';
</style>